import { parse } from "date-fns";
import {
  DeletedDataResponse,
  ParentDetails,
} from "../../api-models/response/organization/DeletedDataResponse";
import { DisplayValue } from "../../components/datatable/interfaces";
import { dateService } from "../date-service/DateService";
import { translationService } from "../translation/TranslationService";
import { SewerObjectType } from "../../generated/SewerObjects";

export class DeletedDataItem {
  id: string;
  private deletedAt?: Date;
  private deletedBy?: string;
  private dataType: string;
  private identifier: string;
  private parentsDetails: ParentDetails[];
  identification: number;
  type: string;

  constructor(deletedDataResponse: DeletedDataResponse) {
    this.id = deletedDataResponse.id + deletedDataResponse.dataType;
    this.deletedAt = deletedDataResponse.deletedAt;
    this.deletedBy = deletedDataResponse.deletedBy;
    this.dataType = `general.${deletedDataResponse.dataType.toLowerCase()}`;
    this.identifier = deletedDataResponse.name;
    this.parentsDetails = deletedDataResponse.parentsDetails;
    this.deletedAt = deletedDataResponse.deletedAt;
    this.identification = deletedDataResponse.id;
    this.type = deletedDataResponse.dataType;
  }

  private getFormattedIdentifier(): string {
    if (this.dataType === "general.inspection") {
      return `${translationService.translate(this.dataType)} ${dateService.formatDate(
        parse(this.identifier, "dd/MM/yyyy", new Date())
      )}`;
    }
    return this.identifier;
  }

  get details(): DisplayValue {
    const parents = this.parentsDetails || [];
    const lastParent = parents.at(-1);

    const toDisplay = lastParent?.id
      ? `${translationService.translate(`general.${lastParent.type.toLowerCase()}`)} ${
          lastParent.date ? dateService.formatDate(lastParent.date) : lastParent.display
        } ${
          lastParent.isDeleted
            ? `(${translationService.translate("general.deleted-data.deleted-parent")})`
            : ""
        }`
      : "";

    const path = lastParent?.id
      ? this.parentsDetails.reduce((previousPath, { id, type }) => {
          if (Object.keys(SewerObjectType).includes(type))
            return (previousPath += `/sewer-objects/${type.toLowerCase()}/${id}`);
          return (previousPath += `/${type.toLowerCase()}s/${id}`);
        }, "")
      : "";

    const isDeleted = lastParent?.isDeleted;

    return { toDisplay, path, isDeleted };
  }

  get displayValues() {
    return {
      dateDeleted: {
        toDisplay: this.deletedAt ? dateService.formatDate(this.deletedAt) : null,
        value: this.deletedAt,
      },
      deletedBy: { toDisplay: this.deletedBy },
      dataType: { toDisplay: translationService.translate(this.dataType) },
      identifier: { toDisplay: this.getFormattedIdentifier() },
      details: this.details,
    };
  }
}
